import { SimulatedDebt } from '@common/apis/simulated-debt/types';

export function isDesenrolaNubank(debt?: SimulatedDebt): boolean {
  const isNubank = !!debt?.partner?.identifier?.includes('nubank');
  const isDesenrola = !!debt?.propriedades?.some((prop) => prop.chave === 'IS_DESENROLA' && prop.valorBoolean === true);
  return isNubank && isDesenrola;
}

export function isNubankDesenrolaGrouped(debt?: any): boolean {
  const isNubank = !!(debt?.partner?.identifier?.includes('nubank') || debt?.partner?.partnerIdentifier === 'nubank');
  const isDesenrola = !!(
    debt?.propriedades?.some((prop: any) => prop.chave === 'IS_DESENROLA' && prop.valorBoolean === true) ||
    debt?.properties?.some((prop: any) => prop.key === 'IS_DESENROLA' && prop.booleanValue === true)
  );
  const isGrouped = !!(
    debt?.propriedades?.some((prop: any) => prop.chave === 'IS_AGRUPADO' && prop.valorBoolean === true) ||
    debt?.properties?.some((prop: any) => prop.key === 'IS_AGRUPADO' && prop.booleanValue === true)
  );
  return isNubank && isDesenrola && isGrouped;
}

interface CheckNubankLoansDueDateParams {
  product: string;
  isNubank: boolean;
  hasBillet: boolean;
  agreementDate: string; // 'YYYY-MM-DD' or Date object
  firstInstallmentExpDate: string; // 'DD/MM/YYYY'
  shouldFormatDate?: boolean;
}

export function checkNubankLoansDueDate({
  product,
  isNubank,
  hasBillet,
  agreementDate,
  firstInstallmentExpDate,
  shouldFormatDate,
}: CheckNubankLoansDueDateParams) {
  const shouldValidateDueDate = product === 'Empréstimo' && isNubank;
  if (!shouldValidateDueDate || hasBillet) return false;

  let agreementDatePlusOne;
  if (shouldFormatDate) {
    const [yearStr, monthStr, dayStr] = agreementDate.split('-');
    agreementDatePlusOne = new Date(Number(yearStr), Number(monthStr) - 1, Number(dayStr));
  } else {
    agreementDatePlusOne = new Date(agreementDate);
  }

  agreementDatePlusOne.setDate(agreementDatePlusOne.getDate() + 1);

  const parseDDMMYYYY = (dmy: string) => {
    const [d, m, y] = dmy.split('/').map(Number);
    return new Date(y, m - 1, d);
  };

  const firstInstallmentDueDate = parseDDMMYYYY(firstInstallmentExpDate);
  const isValidD3 = firstInstallmentDueDate.getTime() > agreementDatePlusOne.getTime(); // data de vencimento > data do acordo + 1

  if (!isValidD3) return false;

  return true;
}
